export enum COLOR_MODE {
  BW = 0,
  COLOR = 1,
}
